<div >
    <section class="signin" role="main">

      <svg soho-icon icon="logo"></svg>

      <div class="field">
        <label for="username-display" required=true>{{userNameText}}</label>
        <input type="text" name="username-display" id="username-display" autocomplete="off" data-validate="required" [(ngModel)]="model.userName">
      </div>

      <div class="field">
        <label for="password-display" required=true>{{passwordText}}</label>
        <input type="password" id="password-display" data-validate="required" [(ngModel)]="model.password">
      </div>

      <form id="signin" data-validate-on="submit" autocomplete="off">
        <a class="hyperlink" href="forgotpassword">{{forgotPasswordText}}</a>

        <label for="username" soho-label audible=true>{{userNameText}}</label>
        <input type="hidden" name="username" id="username"  >
        <label for="password" soho-label audible=true>{{passwordText}}</label>
        <input type="password" id="password" name="password">
      </form>
    </section>
</div>
